var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRealEstate = function SvgIconRealEstate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4398D1"
    },
    points: "467.862,114.759 467.862,344.276 185.379,344.276 185.379,114.759 326.621,26.483 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F8FC4"
    },
    d: "M467.862,114.759l-65.651-41.031c-28.725,110.698-97.13,206.98-192.203,270.548h257.854V114.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8594A"
    },
    points: "512,114.759 326.621,0 141.241,114.759 158.897,150.069 326.621,44.138 494.345,150.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8594A"
    },
    points: "467.862,0 432.552,0 432.552,65.58 467.862,87.437  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 123.586,
    style: {
      fill: "#87CED9"
    },
    width: 35.31,
    height: 70.621
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.931,
    y: 123.586,
    style: {
      fill: "#87CED9"
    },
    width: 35.31,
    height: 70.621
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.931,
    y: 238.345,
    style: {
      fill: "#87CED9"
    },
    width: 35.31,
    height: 70.621
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 238.345,
    style: {
      fill: "#87CED9"
    },
    width: 35.31,
    height: 70.621
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 158.897,
    style: {
      fill: "#61ACC9"
    },
    width: 35.31,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.931,
    y: 158.897,
    style: {
      fill: "#61ACC9"
    },
    width: 35.31,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.931,
    y: 264.828,
    style: {
      fill: "#61ACC9"
    },
    width: 35.31,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 264.828,
    style: {
      fill: "#61ACC9"
    },
    width: 35.31,
    height: 17.655
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.414,
    y: 35.31,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.724,
    y: 35.31,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.103,
    y: 35.31,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.793,
    y: 35.31,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 35.31,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 70.621,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 105.931,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 141.241,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 176.552,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.483,
    y: 211.862,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.103,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.414,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.724,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.724,
    y: 441.379,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.724,
    y: 406.069,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.724,
    y: 370.759,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.793,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 282.483,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 282.483,
    y: 476.69,
    style: {
      fill: "#4398D1"
    },
    width: 17.655,
    height: 17.655
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B44D"
    },
    cx: 132.414,
    cy: 379.586,
    r: 132.414
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FA982F"
    },
    cx: 132.414,
    cy: 379.586,
    r: 97.103
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77219"
    },
    d: "M147.897,432.552H116.93c-15.819-0.018-28.637-12.835-28.654-28.654v-6.656h17.655v6.656 c0.009,6.073,4.926,10.99,10.999,10.999h30.967c6.073-0.009,10.99-4.935,10.99-11.008c-0.009-5.049-3.443-9.437-8.342-10.664 l-40.607-10.143c-15.378-3.743-24.814-19.235-21.071-34.613c3.143-12.906,14.733-21.963,28.019-21.884h30.967 c15.837-0.009,28.69,12.826,28.698,28.663c0,0.009,0,0.018,0,0.026v6.656h-17.655v-6.656c-0.009-6.073-4.926-10.99-10.999-10.999 H116.93c-6.073,0.009-10.99,4.935-10.99,11.008c0.009,5.049,3.443,9.437,8.342,10.664l40.607,10.143 c15.378,3.743,24.814,19.235,21.071,34.613c-3.143,12.906-14.733,21.963-28.019,21.884L147.897,432.552z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.586,
    y: 308.966,
    style: {
      fill: "#F77219"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.586,
    y: 423.724,
    style: {
      fill: "#F77219"
    },
    width: 17.655,
    height: 26.483
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77219"
    },
    d: "M44.138,379.586H26.483c0.062-58.474,47.457-105.869,105.931-105.931v17.655 C83.686,291.363,44.191,330.858,44.138,379.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77219"
    },
    d: "M132.414,485.517v-17.655c48.728-0.053,88.223-39.548,88.276-88.276h17.655 C238.283,438.06,190.888,485.455,132.414,485.517z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRealEstate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-real-estate.d5094c49.svg";
export { ForwardRef as ReactComponent };